import React, { PropsWithChildren } from 'react'
import { ISbRichtext } from 'storyblok-js-client'
import renderRichText from '../../../utils/richTextResolver'
import classes from './headerOptionOne.module.scss'

export type HeaderOptionOneProps = {
  title: string
  description: ISbRichtext
  withDescription?: boolean
  component?: string
}

const HeaderOptionOne: React.FC<PropsWithChildren<HeaderOptionOneProps>> = ({ title, description }) => {
  return (
    <div className={classes.headerOptionOneWrapper}>
      <div className={classes.withDescriptionContainer}>
        <h1 className={classes.title}>{title}</h1>
        <div
          className={classes.description}
          dangerouslySetInnerHTML={{ __html: renderRichText(description) }}
        >
        </div>

      </div>
    </div>
  )
}

export default HeaderOptionOne
